import { WebsiteContentMessage, SendEmailMessage } from 'sections/onsite-campaigns/types';
import { CampaignEditorState, CampaignMessage } from '../../../contexts/CampaignEditorState';
import { SplitTestsState } from '../../../tabs/CampaignWorkflowTab/state/SplitTests/SplitTestsState';
import { Branches } from '../../../tabs/CampaignWorkflowTab/state/Branches/BranchesState';
import { CanvasState } from '../../../tabs/CampaignWorkflowTab/components/Canvas/state/CanvasState';

export type MapMessageSegmentsModel = {
  onsiteMessages: CampaignMessage<WebsiteContentMessage>[];
  offsiteMessages: CampaignMessage<SendEmailMessage>[];
  prevOnsiteMessages: CampaignMessage<WebsiteContentMessage>[];
  prevOffsiteMessages: CampaignMessage<SendEmailMessage>[];
  branchNames: Branches;
  splitTests: SplitTestsState;
  prevSplitTests: SplitTestsState;
};

const findMessageIdForBranchNode = (branchNodeId: string, canvasState: CanvasState) => {
  const edge = canvasState.edges.find(s => s.source === branchNodeId);
  return edge?.target;
};

export class MessageSegmentationMapperModel {
  private static mapMessages(state: CampaignEditorState, messageType: string): CampaignMessage<any>[] {
    return Object.values(state.messages)
      .filter(message => message.messageType === messageType)
      .map(message => message as CampaignMessage<WebsiteContentMessage | SendEmailMessage>);
  }

  public static map(
    prevState: CampaignEditorState,
    state: CampaignEditorState,
    canvasState: CanvasState,
  ): MapMessageSegmentsModel {
    const messages = {
      onsiteMessages: this.mapMessages(state, 'onsite'),
      offsiteMessages: this.mapMessages(state, 'offsite'),
    };

    const prevMessages = {
      onsiteMessages: this.mapMessages(prevState, 'onsite'),
      offsiteMessages: this.mapMessages(prevState, 'offsite'),
    };

    const branchNames: Branches = Object.values(state.branches).reduce((prev, branch, i) => {
      const messageId = findMessageIdForBranchNode(branch.id, canvasState);
      return {
        ...prev,
        [messageId ?? i]: branch,
      };
    }, {});

    return {
      ...messages,
      prevOnsiteMessages: prevMessages.onsiteMessages,
      prevOffsiteMessages: prevMessages.offsiteMessages,
      branchNames,
      splitTests: state.splitTests ?? {},
      prevSplitTests: prevState.splitTests ?? {},
    };
  }
}
